import React, { useState, createContext, useContext } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { LeadForm } from './LeadForm';
type FormModalContextType = {
  openFormModal: () => void;
};
const FormModalContext = createContext<FormModalContextType>({
  openFormModal: () => {}
});
export function useFormModal() {
  return useContext(FormModalContext);
}
export function FormModalProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const openFormModal = () => setIsOpen(true);
  const closeFormModal = () => setIsOpen(false);
  return <FormModalContext.Provider value={{
    openFormModal
  }} data-id="element-95">
      {children}

      <AnimatePresence data-id="element-96">
        {isOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={closeFormModal} data-id="element-97">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-98" />

            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="relative z-10 w-full max-w-md" onClick={e => e.stopPropagation()} data-id="element-99">
              <button onClick={closeFormModal} className="absolute -top-12 right-0 text-white/60 hover:text-white transition-colors p-2" aria-label="Close form" data-id="element-100">
                <XIcon className="w-6 h-6" data-id="element-101" />
              </button>
              <LeadForm data-id="element-102" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </FormModalContext.Provider>;
}